import { nanoid } from 'nanoid';
import { showToast, TOAST_TYPES } from '../components/common/ToastManager';
import { ROLE_DATA_STRUCTURE } from '../utils/dataStructure';

const API_URL = 'https://muddy-river-a54e.philip-d02.workers.dev';

const generatePermalink = (companyName, roleTitle) => {
  const sanitize = (str) => str
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');
  
  return `${sanitize(companyName)}-${sanitize(roleTitle)}-${nanoid(8)}`;
};

const formatDataForStorage = (roleData) => {
  return {
    company: roleData.companyData.name,
    roleName: roleData.roleData.jobTitle,
    data: {
      companyData: roleData.companyData,
      roleData: roleData.roleData,
      timelines: {
        targetStartDate: roleData.timelines?.targetStartDate || '',
        steps: Array.isArray(roleData.timelines?.steps)
          ? roleData.timelines.steps
              .filter(step => step && step.text?.trim() && step.date)
              .map(step => ({
                text: step.text.trim(),
                date: step.date,
                duration: step.duration || ''
              }))
          : []
      },
      responsibilities: Array.isArray(roleData.responsibilities)
        ? roleData.responsibilities
            .filter(resp => resp && resp.text?.trim())
            .map(resp => ({ text: resp.text.trim() }))
        : [],
      outcomes: Array.isArray(roleData.outcomes)
        ? roleData.outcomes
            .filter(outcome => outcome && outcome.text?.trim() && outcome.timeframe?.trim())
            .map(outcome => ({
              text: outcome.text.trim(),
              timeframe: outcome.timeframe.trim()
            }))
        : []
    }
  };
};

export const saveRole = async (roleData) => {
  try {
    // Only validate company name and job title
    if (!roleData.companyData?.name?.trim()) {
      showToast('Company name is required', TOAST_TYPES.WARNING);
      throw new Error('Company name is required');
    }

    if (!roleData.roleData?.jobTitle?.trim()) {
      showToast('Job title is required', TOAST_TYPES.WARNING);
      throw new Error('Job title is required');
    }

    const formattedData = formatDataForStorage(roleData);
    
    console.log('[saveRole] Formatted data being sent to worker:', formattedData);
    console.log('[saveRole] Data structure validation:', {
      hasOutcomes: formattedData.data.outcomes?.length > 0,
      hasResponsibilities: formattedData.data.responsibilities?.length > 0,
      hasTimelines: formattedData.data.timelines?.steps?.length > 0,
      outcomesCount: formattedData.data.outcomes?.length,
      responsibilitiesCount: formattedData.data.responsibilities?.length,
      timelineStepsCount: formattedData.data.timelines?.steps?.length
    });

    showToast('Saving role...', TOAST_TYPES.INFO);
    const response = await fetch(`${API_URL}/roles`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formattedData)
    });

    if (!response.ok) {
      const error = await response.json();
      showToast(error.message || 'Failed to save role', TOAST_TYPES.ERROR);
      throw new Error(error.message || 'Failed to save role');
    }

    const { url } = await response.json();
    showToast('Role saved successfully! ✨', TOAST_TYPES.SUCCESS);
    return url;
  } catch (error) {
    console.error('Error saving role:', error);
    throw error;
  }
};

export const loadRole = async (permalink) => {
  try {
    const response = await fetch(`${API_URL}/roles/${permalink}`);
    if (!response.ok) throw new Error('Failed to load role');
    
    const { data } = await response.json();
    return data;
  } catch (error) {
    console.error('Error loading role:', error);
    throw error;
  }
}; 